(() => {
  const storageKey = 'sxt-home-gender';
  const validGenders = new Set(['women', 'men']);

  // Четем запазения избор безопасно, без да блокираме страницата при забранен storage.
  const readSavedGender = () => {
    try {
      const saved = window.localStorage.getItem(storageKey);
      return validGenders.has(saved) ? saved : null;
    } catch (_error) {
      return null;
    }
  };

  const saveGender = (gender) => {
    try {
      window.localStorage.setItem(storageKey, gender);
    } catch (_error) {
      // Страницата продължава да работи и при изключени cookies/storage.
    }
  };

  const applyGender = (gender, persist = false) => {
    const nextGender = validGenders.has(gender) ? gender : 'women';
    document.documentElement.dataset.sxtHomeGender = nextGender;

    document.querySelectorAll('[data-sxt-gender-button]').forEach((button) => {
      const isActive = button.dataset.sxtGenderButton === nextGender;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    // hidden пази скритата витрина извън tab реда и screen reader навигацията.
    document.querySelectorAll('[data-sxt-audience]').forEach((section) => {
      const audience = section.dataset.sxtAudience || 'all';
      section.hidden = audience !== 'all' && audience !== nextGender;
    });

    if (persist) saveGender(nextGender);
  };

  const initialise = () => {
    const switcher = document.querySelector('[data-sxt-gender-switch]');
    if (!switcher) return;

    const urlGender = new URLSearchParams(window.location.search).get('sxt_gender');
    const initialGender = validGenders.has(urlGender)
      ? urlGender
      : readSavedGender() || switcher.dataset.defaultGender || 'women';

    applyGender(initialGender);

    document.querySelectorAll('[data-sxt-gender-button]').forEach((button) => {
      if (button.dataset.sxtGenderBound === 'true') return;
      button.dataset.sxtGenderBound = 'true';
      button.addEventListener('click', () => applyGender(button.dataset.sxtGenderButton, true));
    });
  };

  document.addEventListener('DOMContentLoaded', initialise, { once: true });
  document.addEventListener('shopify:section:load', initialise);
  // Редакторът трябва да може да отвори и секция от другата витрина.
  const revealEditorSection = (event) => {
    const section = event.target.closest('[data-sxt-audience]') || event.target.querySelector('[data-sxt-audience]');
    if (section && validGenders.has(section.dataset.sxtAudience)) {
      applyGender(section.dataset.sxtAudience);
    }
  };
  document.addEventListener('shopify:section:select', revealEditorSection);
  document.addEventListener('shopify:block:select', revealEditorSection);
  initialise();
})();
